import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  okr_reminder_change: {}, // 提醒成员更新
  okr_date_time_change: {}, // 时间变更(筛选和赋值)
  okr_duiq_reference_kr: {}, // 对齐目标或者任务关联kr
  okr_x_x_data: {}, // kr信心指数变更
  okr_add_edit_event: {},
  progress_weight_change: {}, // 权重和进度修改
  okr_create_kr_task_event: {}, // 创建kr或者kr任务的完成
  okr_kr_data_change: {} // okr或者kr数据变更
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.OKR_REMINDER_CHANGE](state, data) {
    state.okr_reminder_change = data
  },
  [types.OKR_DATE_TIME_CHANGE](state, data) {
    state.okr_date_time_change = data
  },
  [types.OKR_DUIQI_REFERENCE_KR](state, data) {
    state.okr_duiq_reference_kr = data
  },
  [types.OKR_X_X_CAHNGE](state, data) {
    state.okr_x_x_data = data
  },
  [types.OKR_ADD_EDIT_EVENT](state, data) {
    state.okr_add_edit_event = data
  },
  [types.PROGRESS_WEIGHT_CHANGE](state, data) {
    state.progress_weight_change = data
  },
  [types.OKR_CREATE_KR_TASK_EVENT](state, data) {
    state.okr_create_kr_task_event = data
  },
  [types.OKR_KR_DATA_CHANGE](state, data) {
    state.okr_kr_data_change = data
  }
}
// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}
